import { render, staticRenderFns } from "./Post_Loading.vue?vue&type=template&id=41377c40&"
import script from "./Post_Loading.vue?vue&type=script&lang=js&"
export * from "./Post_Loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports